import { CssSelectors } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	modal: {
		...CssSelectors.allDescendants(
			{
				borderRadius: 8,
				boxSizing: 'content-box',
				padding: 18,
				maxWidth: 1000,
			},
			'.modal-overlay-content'
		),
	},
	nameCellContent: {
		display: 'flex',
		flexDirection: 'column',
	},
	nameCell: {
		width: 300,
	},
	smallCell: {
		width: 75,
	},
	mediumCell: {
		width: 100,
	},
	titleCell: {
		width: 250,
	},
	name: {},
	noBorder: {
		border: 'none',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 900,
		padding: 16,
		paddingTop: 0,
	},
	subTitle: {
		marginTop: 20,
		marginBottom: 16,
	},
	title: {
		color: '#0265FF',
		margin: 0,
		marginTop: '-8px',
	},
	content: {
		marginTop: 16,
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-start',
		gap: 16,
		marginTop: 24,
	},
	secondRow: {
		fontSize: 12,
		color: '#9198A4',
	},
	th: {
		color: '#9198A4',
		padding: '8px 16px 8px 16px',
		fontWeight: 400,
	},
	td: {
		display: 'flex',
		alignItems: 'center',
		verticalAlign: 'middle',
		border: '1px solid #E9EBEF',
		borderLeft: 'none',
		padding: '12px 16px 12px 16px',
		':first-of-type': {
			borderLeft: '1px solid #E9EBEF',
			borderTopLeftRadius: 8,
		},
	},
	fullCell: {
		width: '100%',
	},
	bottomLeftTd: {
		borderBottomLeftRadius: 8,
	},
	bottomRightTd: {
		borderBottomRightRadius: 8,
	},
	lastTd: {
		borderTopRightRadius: 8,
	},
	centered: {
		display: 'flex',
		textAlign: 'center',
		verticalAlign: 'middle',
	},
	table: {
		verticalAlign: 'middle',
		width: '100%',
		fontSize: 14,
	},
	tableRow: {
		display: 'flex',
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 12,
		width: 125,
	},
});
